module.exports = __webpack_public_path__ + "images/dir-small-empty@2x-9aa9b64956c5d72135d92d96981c6365.png";